//import 'jQuery';
import "./modernizr";
import "./jquery.toggle";

// Global var
window.body = jQuery("body");
window.html = jQuery("html");
window.transitionDuration = "250";

var aziendeContent;

jQuery(function () {
  if (jQuery(".home-eventi").length) {
    if (jQuery("ul > li.eventTitle").length) {
      var noEventsItem = jQuery("ul > li.eventTitle");

      noEventsItem.removeClass("eventTitle").addClass("eventItem mb-3");

      noEventsItem.html(
        '<a href="#" class="eventLink row"><div class="col-10 col-md-4"><div class="event__imgHolder" style="background-image:url(\'http://aiad.fabaris.it/content/themes/aiad/ui/images/placeholder-transparent.png\')"><img width="128" height="130" src="http://aiad.fabaris.it/content/themes/aiad/ui/images/placeholder-transparent.png" class="attachment-230x130 size-230x130 wp-post-image" alt="" loading="lazy" /></div></div><div class="eventMeta col-10 col-md-6"><span class="eventLocationDate" style="font-weight: bold"></span><h4 class="eventTitle">Non ci sono eventi</h4></div></a>'
      );
    }

    var aziende = jQuery(".home-eventi > .col-10")
      .first()
      .wrap('<div class="placeholder"></div>')
      .parent();
    aziendeContent = aziende.html();

    aziende.remove();

    jQuery(".home-eventi").wrapInner(
      '<div class="col-10 col-md-5 evts mb-3 mb-md-0"></div>'
    );
  }

  if (jQuery(".css-events-list").length) {
    jQuery(".css-events-list")
      .parent()
      .next(".wpml-ls-statics-post_translations")
      .remove();
  }

  if (jQuery(".hero-iconWrap").length) {
    jQuery(".hero-iconWrap").insertAfter(".main-navigation");
  }
});

window.addEventListener("DOMContentLoaded", function () {
  var currentTrigger = JSON.parse(
    window.sessionStorage.getItem("modal-openedby")
  );

  if (currentTrigger) {
    var target = currentTrigger;
    document.querySelector('[data-action="' + target + '"]').click();
  }

  // if (document.body.classList.contains("home")) {
  //   var target = document.querySelector(".home-eventi ul");
  //   var title = document.createElement("h4");
  //   var listItem = document.createElement("li");
  //   title.classList.add("block__title");
  //   title.textContent = "Prossimi Eventi";
  //   target.insertAdjacentElement("afterbegin", listItem);
  //   listItem.insertAdjacentElement("afterbegin", title);
  // }

  if (document.body.classList.contains("single-aziende-federate")) {
    GLightbox({
      selector: "glightbox",
      touchNavigation: true,
      loop: true,
    });
  }
  if (document.querySelector("#gform_fields_login")) {
    var parent = document.querySelector(".gform_footer");
    var newLabel = document.createElement("label");
    newLabel.setAttribute("for", "trigger-recovery");
    newLabel.setAttribute("data-action", "reset");
    newLabel.textContent = "Hai dimenticato la password?";
    parent.insertAdjacentElement("afterbegin", newLabel);
  }
  if (!document.body.classList.contains("logged-in")) {
    var elements = [
      "#close-modal",
      "#trigger-login",
      "#trigger-register",
      "#trigger-recovery",
    ];
    Array.prototype.forEach.call(elements, function (element) {
      document.querySelector(element).addEventListener("change", function (e) {
        var curTarget = e.target.getAttribute("data-action");
        switch (curTarget) {
          case "login":
            setStorage("login");
            break;
          case "register":
            setStorage("register");
            break;
          case "recovery":
            setStorage("recovery");
            break;
          case "close":
            window.sessionStorage.removeItem("modal-openedby");
            break;
        }
      });
    });

    document
      .querySelector(".modal__content--register li:last-child a")
      .addEventListener("click", function () {
        window.sessionStorage.removeItem("modal-openedby");
      });

    function setStorage(type) {
      window.sessionStorage.setItem("modal-openedby", JSON.stringify(type));
    }
  } else {
    document.querySelector("#close-modal").click();
    window.sessionStorage.removeItem("modal-openedby");
  }
  // if(window.innerWidth <= 1198){
  var target;
  if (window.innerWidth <= 768) {
    target = "";
    target = document.body.querySelector(".header__userAvatar");
  } else {
    target = "";
    target = document.body.querySelector(".header__user");
  }
  target.addEventListener("click", function () {
    var menu = document.body.querySelector(".user-menu");
    menu.classList.toggle("active");
  });
  // }
  if (window.location.href.indexOf("/eventi") > -1) {
    var customStyle = `
                .ui-datepicker {
                        height: auto!important;
                        margin: 5px 0!important;
                        font: 9pt Arial, sans-serif!important;
                        -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, .5)!important;
                        -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, .5)!important;
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, .5)!important;
                }
                .ui-datepicker a {
                        text-decoration: none!important;
                }
                /* DatePicker Table */
                .ui-datepicker table {
                        width: 100%!important;
                }
                .ui-datepicker-header {
                        background: #000!important;
                        color: #e0e0e0!important;
                        font-weight: bold!important;
                        -webkit-box-shadow: inset 0px 1px 1px 0px rgba(250, 250, 250, 2)!important;
                        -moz-box-shadow: inset 0px 1px 1px 0px rgba(250, 250, 250, .2)!important;
                        box-shadow: inset 0px 1px 1px 0px rgba(250, 250, 250, .2)!important;
                        text-shadow: 1px -1px 0px #000!important;
                        filter: dropshadow(color=#000, offx=1, offy=-1)!important;
                        line-height: 30px!important;
                        border-width: 0!important;
                        border-style: solid;!important
                        border-color: #111!important;
                        padding: .4em 0!important;
                }
                .ui-datepicker-title {
                        text-align: center!important;
                }
                .ui-datepicker-prev, .ui-datepicker-next {
                        display: inline-block!important;
                        width: 30px!important;
                        height: 30px!important;
                        text-align: center!important;
                        cursor: pointer!important;
                        background-image: url('./images/arrow.png')!important;
                        background-repeat: no-repeat!important;
                        line-height: 600%!important;
                        overflow: hidden!important;
                        top:0px!important;
                }
                .ui-datepicker-prev {
                        float: left!important;
                        background-position: center -30px!important;
                }
                .ui-datepicker-next {
                        float: right!important;
                        background-position: center 0px!important;
                }
                .ui-datepicker thead {
                        background-color: #f7f7f7;
                        background-image: -moz-linear-gradient(top,  #f7f7f7 0%, #f1f1f1 100%)!important;
                        background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f7f7f7), color-stop(100%,#f1f1f1))!important;
                        background-image: -webkit-linear-gradient(top,  #f7f7f7 0%,#f1f1f1 100%)!important;
                        background-image: -o-linear-gradient(top,  #f7f7f7 0%,#f1f1f1 100%)!important;
                        background-image: -ms-linear-gradient(top,  #f7f7f7 0%,#f1f1f1 100%)!important;
                        background-image: linear-gradient(top,  #f7f7f7 0%,#f1f1f1 100%)!important;
                        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f7f7f7', endColorstr='#f1f1f1',GradientType=0 )!important;
                        border-bottom: 1px solid #bbb!important;
                }
                .ui-datepicker th {
                        text-transform: uppercase!important;
                        padding: 5px 0!important;
                        color: #666666!important;
                        text-align:center!important;
                        text-shadow: 1px 0px 0px #fff!important;
                        filter: dropshadow(color=#fff, offx=1, offy=0)!important;
                }
                .ui-datepicker tbody td {
                        padding: 0!important;
                        border-right: 1px solid #bbb!important;
                }
                .ui-datepicker tbody td:last-child {
                        border-right: 0px!important;
                }
                .ui-datepicker tbody tr {
                        border-bottom: 1px solid #bbb!important;
                }
                .ui-datepicker tbody tr:last-child {
                        border-bottom: 0px!important;
                }
                .ui-datepicker td span, .ui-datepicker td a {
                        display: inline-block!important;
                        font-weight: bold!important;
                        text-align: center!important;
                        width: 100%!important;
                        height: 30px!important;
                        line-height: 30px!important;
                        color: #666666!important;
                        text-shadow: 1px 1px 0px #fff!important;
                        filter: dropshadow(color=#fff, offx=1, offy=1)!important;
                        box-shadow:none;border:0px!important;
                }
                .ui-datepicker-calendar .ui-state-default {
                        background: #ededed!important;
                        background: -moz-linear-gradient(top,  #ededed 0%, #dedede 100%)!important;
                        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#ededed), color-stop(100%,#dedede))!important;
                        background: -webkit-linear-gradient(top,  #ededed 0%,#dedede 100%)!important;
                        background: -o-linear-gradient(top,  #ededed 0%,#dedede 100%)!important;
                        background: -ms-linear-gradient(top,  #ededed 0%,#dedede 100%)!important;
                        background: linear-gradient(top,  #ededed 0%,#dedede 100%)!important;
                        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ededed', endColorstr='#dedede',GradientType=0 )!important;
                        -webkit-box-shadow: inset 1px 1px 0px 0px rgba(250, 250, 250, .5)!important;
                        -moz-box-shadow: inset 1px 1px 0px 0px rgba(250, 250, 250, .5)!important;
                        box-shadow: inset 1px 1px 0px 0px rgba(250, 250, 250, .5)!important;
                }
                .ui-datepicker-calendar .ui-state-hover {
                        background: #f7f7f7!important;
                        box-shadow:none!important;
                        border:0px!important
                }
                .ui-datepicker-calendar .ui-state-active {
                        background: #6eafbf;
                        -webkit-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, .1)!important;
                        -moz-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, .1)!important;
                        box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, .1)!important;
                        color: #e0e0e0!important;
                        text-shadow: 0px 1px 0px #4d7a85!important;
                        filter: dropshadow(color=#4d7a85, offx=0, offy=1)!important;
                        border: 1px solid #55838f!important;
                        position: relative!important;
                }
                .ui-datepicker-unselectable .ui-state-default {
                        background: #f4f4f4!important;
                        color: #b4b3b3!important;
                }
                .ui-datepicker-calendar .ui-state-active {
                        background: #6eafbf!important;
                        -webkit-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, .1)!important;
                        -moz-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, .1)!important;
                        box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, .1)!important;
                        color: #e0e0e0!important;
                        text-shadow: 0px 1px 0px #4d7a85!important;
                        filter: dropshadow(color=#4d7a85, offx=0, offy=1)!important;
                        border: 1px solid #55838f!important;
                        position: relative!important;
                }
                `;
    var reset = document.createElement("style");
    reset.textContent = customStyle;
    reset.type = "text/css";
    reset.id = "datepicker-reset";
    document.head.insertAdjacentElement("beforeend", reset);
  }
});

jQuery(function () {
  setTimeout(function () {
    if (jQuery(".home-eventi").length) {
      jQuery(aziendeContent).insertBefore(".home-eventi .evts");
    }
  }, 500);
});

// Uncomment to enable Bootstrap tooltips
// https://getbootstrap.com/docs/4.0/components/tooltips/#example-enable-tooltips-everywhere
// $(function () { $('[data-toggle="tooltip"]').tooltip(); });

// Uncomment to enable Bootstrap popovers
// https://getbootstrap.com/docs/4.0/components/popovers/#example-enable-popovers-everywhere
// $(function () { $('[data-toggle="popover"]').popover(); });

jQuery(function () {
  console.log("DOM Loaded.");

  jQuery(".eventItem").each(function () {
    var item = jQuery(this);
    var imgHolder = item.find(".event__imgHolder");

    imgHolder.find("img").wrap('<span class="event__imgContainer"></span>');

    var background = imgHolder.attr("style");

    imgHolder.find(".event__imgContainer").attr("style", background);
    imgHolder.attr("style", "");

    var locationDate = item.find(".eventLocationDate");
    var locationDateTrim = locationDate.text().trim();

    if (locationDateTrim.startsWith("-")) {
      locationDate.text(locationDateTrim.substring(2));
    }
  });

  if (jQuery(".block__subtitle").length) {
    var subtitle = jQuery(".block__subtitle").clone();
  }

  jQuery(
    '[lang*="en"] .single-aziende-federate .wpml-ls-statics-post_translations ~ .wpml-ls-statics-post_translations'
  )
    .prevUntil(".block__title")
    .not(".block__subtitle")
    .remove();

  jQuery('[lang*="it"] .single-aziende-federate .info.row')
    .prevUntil(".block__title")
    .not(":eq(0)")
    .remove();

  if (subtitle !== undefined) {
    var title = jQuery(
      '[lang*="it"] .single-aziende-federate .post .block__title'
    );

    subtitle.insertAfter(title);

    jQuery(".block__subtitle + .block__subtitle").remove();
  }

  jQuery('[data-action*="print"]').click(function () {
    window.print();
  });
  jQuery('[data-action*="hide"]').click(function () {
    window.sessionStorage.removeItem("modal-openedby");
  });
  jQuery('[for="trigger-formOfferteCommerciali"]').click(function () {
    window.sessionStorage.removeItem("modal-openedby");
  });
  jQuery('[data-action*="open"]').click(function () {
    window.sessionStorage.setItem("modal-openedby", "offer");
    console.log(window.sessionStorage.getItem("modal-openedby"));
  });
  jQuery(document).on("ready", function () {
    console.log("ready");
    if (window.sessionStorage.getItem("modal-openedby") == "offer") {
      jQuery('[data-action*="open"]').click();
    }
  });

  if (jQuery(".archive-content").length) {
    var contenutoArchivio = jQuery(".archive-content")
      .html()
      .replace(new RegExp("\r?\n", "g"), "<br>")
      .replace(new RegExp("<br><br>", "g"), "</p><p>");
    var parsedContenutoArchivio = "<p>" + contenutoArchivio + "</p>";

    jQuery(".archive-content").html(parsedContenutoArchivio);
    jQuery(".archive-content")
      .children()
      .first("p")
      .children()
      .first("br")
      .remove();
  }

  if (jQuery('[name*="cp_appbooking"]').length) {
    var privacyPolicyLink = jQuery('[vt="acconsento"]').parent().find("a");
    var privacyPolicyURL = jQuery('[vt="acconsento"]')
      .parent()
      .find("a")
      .attr("href");

    jQuery(
      '<p style="margin-bottom: 0;">Vai alla pagina dedicata alla <a href="' +
        privacyPolicyURL +
        '">Privacy Policy</a></p>'
    ).insertAfter(privacyPolicyLink.parents("label"));

    privacyPolicyLink
      .parent()
      .html("Dichiaro di aver preso visione e ben compreso la privacy policy");
  }

  if (window.sessionStorage.getItem("modal-openedby") == '"recovery"') {
    // url: /recupero-password-inviato/
    if (jQuery(".post#post-37551").length) {
      document.querySelector("#close-modal").click();
      window.sessionStorage.removeItem("modal-openedby");
    }
  }

  jQuery(function () {
    jQuery(".truncate").succinct({
      size: 50,
    });
  });

  jQuery(function () {
    var breadcrumbsSingle = jQuery(".single-offerte-commerciali").find(
      "#breadcrumbs"
    );
    var breadcrumbsArchive = jQuery(
      ".post-type-archive-offerte-commerciali"
    ).find("#breadcrumbs");
    breadcrumbsArchive
      .find("a")
      .next()
      .text("Opportunità nazionali e internazionali");
    breadcrumbsSingle
      .find("a")
      .next()
      .find("a")
      .text("Opportunità nazionali e internazionali");

    var breadcrumbsPaginaHomeOfferte = jQuery("#breadcrumbs")
      .find("a")
      .next()
      .text();
    var breadcrumbsBandiGara = jQuery("#breadcrumbs")
      .find("a")
      .next()
      .find("a");

    if (breadcrumbsPaginaHomeOfferte == "Opportunità Commerciali") {
      jQuery("#breadcrumbs")
        .find("a")
        .next()
        .text("Opportunità nazionali e internazionali");
    } else if (breadcrumbsBandiGara.text() == "Opportunità Commerciali") {
      breadcrumbsBandiGara.text("Opportunità nazionali e internazionali");
    }
  });
  jQuery(function () {
    var body = jQuery(".page");
    var arr = body.find(".wpml-ls-statics-post_translations");
    if (arr.length > 1) {
      body
        .find(".wpml-ls-statics-post_translations")
        .eq(1)
        .css("display", "none");
    }
  });

  jQuery('<li><h4 class="block__title">Prossimi Eventi</h4></li>').insertBefore(
    jQuery(".evts > ul > li").first()
  );
});
